/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import FancyMarkDownTable from '../../components/_atoms/FancyMarkDownTable';
import Image from 'next/image';
import Ideas from '/public/static/5-Ideas.png';
import workplaceicebreaker from '/assets/images/LandingPage/workplaceicebreaker.png';
import meetingsVennDiagramImage from '/assets/images/LandingPage/meetings-venn-diagram.png';
import whatwherehighlightsoftheweekpodium from '/assets/images/LandingPage/whatwherehighlightsoftheweekpodium.png';
import whomadeyourweekwordcloud from '/assets/images/LandingPage/whomadeyourweekwordcloud.png';
import projectleadsteve from '/assets/images/LandingPage/projectleadsteve.png';
import myfirstjob from '/assets/images/LandingPage/myfirstjob.png';
import HybridMeetings from '/assets/images/LandingPage/hybrid-meetings.png';
export const meta = {
  author: 'Jens Arre Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  meta: meta,
  title: "5 tips to handle the workplace challenge of this decade: Hybrid meetings",
  subTitle: "I hope these 5 tips will radically improve your hybrid meeting experience",
  image: HybridMeetings,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      a: "a",
      h2: "h2",
      strong: "strong",
      h3: "h3"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.p, {
        children: " \n "
      }), "\n", _jsxs(_components.p, {
        children: ["The pandemic has changed how people work all over the world. We want more flexibility, in how, when and where we work. At the same time however, research shows that we also crave more in-person time with our teams. The CEO of Microsoft, ", _jsx(_components.a, {
          href: "https://blogs.microsoft.com/blog/2021/09/09/microsoft-and-linkedin-share-latest-data-and-innovation-for-hybrid-work/",
          children: "Satya Nadella termed this the Hybrid Work Paradox"
        }), ", and argues that it will be the challenge of this decade."]
      }), "\n", _jsx(_components.p, {
        children: " \n "
      }), "\n", _jsx(_components.h2, {
        children: _jsx(_components.strong, {
          children: "The hybrid meetings"
        })
      }), "\n", _jsx(_components.p, {
        children: "A consequence of the Hybrid Work Paradox is that the Hybrid meeting is here to stay. A hybrid meeting is a meeting where some participants are joining in-person/face-to-face, while some join remotely enabled by audio or video conferencing such as Zoom, Teams or Google Meet. The hybrid meetings pose a unique set of challenges for managers and teams. How do you make sure everyone feel included? How do you engage everyone? How do you make high quality discussions where the people joining on Zoom are not interrupted? And how do you do run creative processes and brainstorming?"
      }), "\n", _jsx(Image, {
        src: meetingsVennDiagramImage
      }), "\n", _jsx(_components.p, {
        children: " \n "
      }), "\n", _jsx(_components.h2, {
        children: _jsx(_components.strong, {
          children: "5 tips to improve your hybrid meetings"
        })
      }), "\n", _jsx(_components.p, {
        children: "At Curipod we have some employees working from the office, and some employees working remotely, and we had to experiment to find the best ways to hold remote meetings. Here are five tips based on what we learned."
      }), "\n", _jsx(_components.p, {
        children: " \n "
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Tip 1: Proper equipment"
        })
      }), "\n", _jsx(_components.p, {
        children: "You know the feeling. You join in as a remote participant, and you can’t hear anything of what the in-person participants are saying - and they can’t hear you. The fix for this is simple. Spend some time and money to invest in proper equipment. You won’t even need a large budget. Spending €100 on a proper conference microphone goes a long way."
      }), "\n", _jsx(_components.p, {
        children: " \n "
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Tip 2: Make every in-person participant join the conference call"
        })
      }), "\n", _jsx(_components.p, {
        children: "This tip might not seem that important, but oh does it do wonders for your meetings. Make sure that every in-person participant join the conference call with their camera on (and microphone muted - since you have a common conference mic, see tips 1). In this way, all the meeting participants can see each other which makes it much easier to participate in the discussions for the people joining remotely. Try it out!"
      }), "\n", _jsx(_components.p, {
        children: " \n "
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Tip 3: Make everyone feel included and engaged with a hybrid ice breaker"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["A general challenge with the hybrid meetings is that the remote participants miss out on the chit-chat before the meeting starts, and around the coffee machine in the breaks. It might be tempting to skip this, but setting of 5 minutes to do a social ice breaker where everyone can participate is really important to get a high quality meeting. You can make your own, or you can use one of ", _jsx(_components.a, {
          href: "https://curipod.com/blog/17-workplace-ice-breaker-games-and-activities-for-meetings-and-workshops",
          children: "these ice breaker templates for work."
        })]
      }), "\n", _jsx(_components.p, {
        children: " \n "
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Tip 4: Make sure everyone gets their voice heard"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Even if you follow tips 1 and tips 2, you might experience that it is hard to really get your voice heard as a remote participant in a hybrid meeting. You might want to write something in the Zoom or Teams chat, but we all know how often the on-site people remember to check the chat. As the person leading the meeting you can really benefit from a wide range of tools for this such as Slido, Mentimeter or Miro. However the best way to let everyone ask questions and prioritize them as a group in a fun and time efficient way is by using ", _jsx(_components.a, {
          href: "https://curipod.com/discover/2VowyghNvFbh3UH7XCAt",
          children: "Curipod, for example by using this template."
        })]
      }), "\n", _jsx(_components.p, {
        children: " \n "
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "Tip 5: Find the right software to run creative processes and brainstorming"
        })
      }), "\n", _jsx(_components.p, {
        children: "One of the most difficult types of meetings to do in a hybrid way are the ones including creative processes and brainstorming such as workshops. In a creative workshop it’s even more important that the participants feel safe, engaged and included to produce high quality ideas."
      }), "\n", _jsx(_components.p, {
        children: "It’s also really important that the software you use to facilitate the process is not too complicated to learn for the participants. A poor software experience = a poor workshop result."
      }), "\n", _jsxs(_components.p, {
        children: ["For brainstorming with 2 to 4 persons who are tech savvy, Miro is a brilliant tool. You can collaborate on a shared whiteboard using post-its and other graphical tools. For brainstorming with 5 or more people with varying technological skills, Curipod is amazing. You can ", _jsx(_components.a, {
          href: "https://curipod.com/discover/1HzKGKqb4VC2j0oC3nlz",
          children: "adapt this template"
        }), " to brainstorm anything from: What’s our biggest challenge this quarter, to how can we best meet our customers needs. Expect 100% engagement and participation, and lot’s of great ideas as a result."]
      }), "\n", _jsx(_components.p, {
        children: " \n "
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: "I hope these 5 tips will radically improve you hybrid meeting experience"
        })
      }), "\n", _jsx(_components.p, {
        children: " \n \n \n \n \n "
      })]
    });
  }
}
export default MDXContent;
